import React from "react";
import { Modal, Table, Tag, Space, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { DELIM_LABELS } from "../csvUtils";

const { Text } = Typography;

/**
 * Modal d'aperçu affiché après lecture d'un fichier CSV, avant confirmation
 * définitive de l'import dans le tableau principal.
 *
 * @param {boolean} open - affiche ou non la modal
 * @param {object|null} pendingResult - résultat retourné par buildCSVResult
 *   ({ uniqueHeaders, duplicates, dataRows, delimiter, fileName })
 * @param {() => void} onConfirm - appelé quand l'utilisateur confirme l'import
 * @param {() => void} onCancel - appelé quand l'utilisateur annule
 */
function PreviewModal({ open, pendingResult, onConfirm, onCancel }) {
  // --- Construction de l'aperçu (5 premières lignes) ---
  const previewColumns = pendingResult
    ? pendingResult.uniqueHeaders.map((header, idx) => ({
      title: header,
      dataIndex: `col_${idx}`,
      key: `col_${idx}`,
      ellipsis: true,
    }))
    : [];

  const previewData = pendingResult
    ? pendingResult.dataRows.slice(0, 5).map((r, rowIndex) => {
      const obj = { key: rowIndex };
      pendingResult.uniqueHeaders.forEach((_, idx) => {
        obj[`col_${idx}`] = r[idx] ?? "";
      });
      return obj;
    })
    : [];

  return (
    <Modal
      title="Aperçu avant import"
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Confirmer l'import"
      cancelText="Annuler"
      width={1000}
    >
      {pendingResult && (
        <Space direction="vertical" style={{ width: "100%" }} size="middle">
          <Space wrap>
            <Text>Fichier :</Text>
            <Tag>{pendingResult.fileName}</Tag>
            <Text>Séparateur détecté :</Text>
            <Tag color="blue">
              {DELIM_LABELS[pendingResult.delimiter] || pendingResult.delimiter}
            </Tag>
            <Text>Lignes de données :</Text>
            <Tag color="green">{pendingResult.dataRows.length}</Tag>
            <Text>Colonnes :</Text>
            <Tag color="green">{pendingResult.uniqueHeaders.length}</Tag>
          </Space>

          {pendingResult.duplicates.length > 0 && (
            <Text type="warning">
              <ExclamationCircleOutlined /> Colonnes en double détectées,
              renommées automatiquement : {pendingResult.duplicates.join(", ")}
            </Text>
          )}

          <Text strong>Aperçu des 5 premières lignes :</Text>
          <Table
            columns={previewColumns}
            dataSource={previewData}
            pagination={false}
            size="small"
            scroll={{ x: true }}
          />
        </Space>
      )}
    </Modal>
  );
}

export default PreviewModal;